<template>
    <div class="basic_header">
        <div :class="[
            topClass == 1 ? 'header_nav flex_v_center home_right_div' : 'header_nav flex_v_center', 'header_wrapper' ]">
            <a href="https://www.91jf.com/" target="_blank" class="logo">
                <div class="header_logo_wrapper img_wrapper">
                    <img src="~@/assets/images/basic/header_logo.png" />
                </div>
            </a>
            <span v-if="!excepFlag && path == '/ordering'" class="settle order_settle">结算页
                <em v-if="check_status_text !== '已认证'">
                    <img :src="require('@/assets/images/order/bell.png')" class="bell">温馨提醒：积分和优惠券需 认证 后才能使用。
                    <img :src="require('@/assets/images/basic/Real.png')" class="Real" @click="toReal" /></em></span>
            <span v-if="!excepFlag && path == '/byp/deposit'" class="settle">定金结算页</span>
            <span v-if="!excepFlag && path == '/byp/order'" class="settle">尾款结算页</span>
            <a v-for="(menu, index) in topMenu" :key="'header_navs_' + index" :href="menu.path" :class="menu.class">
                {{ menu.title === '账户管理' ? '' : menu.title }}

                <a-popover v-if="menu.title === '账户管理'" trigger="hover" placement="bottom">
                    <template #content>
                        <p class="sub_menu">
                            <a class="subnavs" :href="sub.path" v-for="(sub, index) in sublist" :key="index">
                                {{ sub.title }}
                            </a>
                        </p>
                    </template>
                    {{ menu.title }} <img :src="require('@/assets/images/basic/more.png')"
                        style="width: 12px; height: 12px;">
                </a-popover>
            </a>
            <a v-if="certInfo != null" href="/cert/account" :class="certInfo.class">{{ certInfo.title }}></a>
            <div v-if="path == '/' || path == '/cart'" class="home_right_adv">
<!--                <img src="@/assets/images/home/intercept.png" class="intercept" @click="toIntercept" />-->
                <a v-if="topImg" @click="toUrl">
                    <img :src="topImg" class="top_img" />
                </a>
                <!-- <a v-else target="_blank" href="https://detail.91jf.com/channel/research">
                <img  src="~@/assets/images/home/home_adv.png"  class="top_img"/>
            </a> -->

            </div>
            <div class="step_wrapper order_wrapper" v-if="!excepFlag && path == '/ordering'">
                <div class="step_images">
                    <img src="~@/assets/images/basic/settle_step_1.png" class="first" />
                    <span class="lining"></span>
                    <img src="~@/assets/images/basic/settle_step_2.png" class="second" />
                    <span class="line"></span>
                    <img src="~@/assets/images/basic/settle_step_3.png" class="three" />
                </div>
                <div class="step_text">
                    <span class="step_txt step_label1">我的采购车</span>
                    <span class="step_txt step_label2">填写订单信息</span>
                    <span class="step_txt step_label3">成功提交订单</span>
                </div>
            </div>
            <div class="step_wrapper" v-if="!excepFlag && path == '/byp/deposit'">
                <div class="step_images">
                    <img src="~@/assets/images/basic/settle_step_1.png" class="first" />
                    <span class="lining" style="background:#d8d8d8;"></span>
                    <img src="~@/assets/images/run/step2.png" class="second" />
                    <span class="line"></span>
                    <img src="~@/assets/images/basic/settle_step_3.png" class="three" />
                </div>
                <div class="step_text">
                    <span class="step_txt step_label1">付定金</span>
                    <span class="step_txt step_label2">成团付尾款</span>
                    <span class="step_txt step_label3">成功提交订单</span>
                </div>
            </div>
            <div class="step_wrapper" v-if="!excepFlag && path == '/byp/order'">
                <div class="step_images">
                    <img src="~@/assets/images/basic/settle_step_1.png" class="first" />
                    <span class="lining"></span>
                    <img src="~@/assets/images/basic/settle_step_2.png" class="second" />
                    <span class="line"></span>
                    <img src="~@/assets/images/basic/settle_step_3.png" class="three" />
                </div>
                <div class="step_text">
                    <span class="step_txt step_label1">付定金</span>
                    <span class="step_txt step_label2">成团付尾款</span>
                    <span class="step_txt step_label3">成功提交订单</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BasicHeader',
    props: ['DetailPosition', 'HomePosition', 'Resize'],
    data() {
        return {
            topMenu: [],
            certInfo: null,
            excepUrl: ['/ordering', '/byp/deposit', '/byp/order'],
            excepFlag: true,
            path: '/',
            userinfo: null,
            topClass: 0,
            targetWay: '_blank',
            topImg: '',
            topUrl: '',
            topId: '',
            check_status_text: '',
            midPostion: false,
            visible: false,
            sublist: [{
                path: '/finance/balance',
                title: '账户余额'
            },
            {
                path: '/safe',
                title: '账户与安全'
            },
            {
                path: '/finance/list',
                title: '交易明细'
            },
            {
                path: '/cert/account',
                title: '用户认证'
            },

            {
                path: '/voucher',
                title: '优惠券'
            },

            {
                path: '/address',
                title: '收/发货地址管理'
            },

            {
                path: '/info',
                title: '个人信息'
            },


            ]
        }
    },
    computed: {

    },
    created() {
        if (this.Resize) {
            this.midPostion = true
        }
        this.path = this.$route.path;
        this.checkExcepUrl();
        this.getTopMenu();
        if (this.path == '/' || this.path == '/cart') {
            this.topClass = 1;
        }
        this.getCertInfo()
    },
    mounted() {
        this.getUserInfo();
    },
    methods: {
        toIntercept() {
            this.$router.push('/intercept');
        },
        getUserInfo() {
            var _this = this;
            _this.userinfo = _this.$util.userinfo();

            if (_this.userinfo == null) {
                _this.$util.api('/login/status', {}, function (res) {
                    console.log(res);
                    if (res.code == 10000) {
                        if (_this.excepFlag) {
                            _this.userinfo = res.data;
                            _this.topImg = res.data.top_img;
                            _this.topUrl = res.data.top_url;
                            _this.topId = res.data.top_id;
                        }
                    }
                });
            }
        },
        getTopMenu() {
            const urls = [
                { title: "首页", path: "/" },
                { title: "采购车", path: "/cart" },
                { title: "账户管理" },
                { title: "消息通知", path: "/notice" },
            ]

            const subPath = this.sublist.some(sub => sub.path === this.path) || this.path === '/deposit/apply' || this.path === '/recharge'
            if (this.excepFlag) {
                for (let i = 0; i < urls.length; i++) {
                    if (urls[i].path === this.path || (urls[i].title === "账户管理" && subPath)) {
                        urls[i].class = 'navs current'
                    } else {
                        urls[i].class = 'navs'
                    }
                }
                this.topMenu = urls
            }
        },

        checkExcepUrl() {
            var path = this.$route.path;
            var excep = this.excepUrl;
            var flag = true;

            for (var i = 0; i < excep.length; i++) {
                if (excep[i] == path) {
                    flag = false;
                    break;
                }
            }

            this.excepFlag = flag;
        },
        toUrl() {
            var _this = this;

            if (_this.topId > 0) {
                _this.$util.api('/adv/click', { adv_id: _this.topId, url: _this.topUrl }, function (res) {

                });
            }
            window.open(_this.topUrl, _this.targetWay);
        },
        toReal() {
            window.open('/cert/account', '_blank');
        },

        getCertInfo() {
            var _this = this;
            _this.$util.api('/member/cert/info', {}, res => {
                if (res.code == 10000) {
                    this.check_status_text = res.data.check_status_text
                } else {
                    _this.$message.error(res.msg)
                }
            });
        },


    }
}
</script>

<style scoped>
.basic_header {
    width: 100%;
    background-color: #fff;
}

.header_wrapper {
    width: 1400px;
    margin: 0 auto;
    padding: 8px 0 !important;
}

.intercept {
    width: 115px;
    height: 80px;
    cursor: pointer;
}

.step_label3 {
    right: 0;
    color: #d8d8d8 !important;
}

.step_label2 {
    left: 240px;
}

.step_label1 {
    left: 0;
}

.three {
    right: 35px;
}

.second {
    left: 270px;
}

.first {
    left: 20px;
}

.step_txt {
    color: #333333;
    font-size: 16px;
    line-height: 28px;
    position: absolute;
    top: 0;
}

.line {
    width: 170px;
    height: 1px;
    background: #d8d8d8;
    display: inline-block;
    position: absolute;
    top: 17px;
    right: 98px;
}

.lining {
    width: 170px;
    height: 1px;
    background: #fd5902;
    display: inline-block;
    position: absolute;
    top: 17px;
    left: 78px;
}

.step_images img {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 0;
}

.step_text {
    width: 100%;
    height: 28px;
    position: relative;
}

.step_images {
    width: 100%;
    height: 36px;
    position: relative;
}

.step_wrapper {
    position: absolute;
    right: 1%;
    width: 600px;
}

.settle {
    color: #666666;
    font-size: 24px;
    margin-left: 5px;
    /* margin-top: 25px; */
}

.order_settle {
    display: flex;
    align-items: center;
    width: 35%;
    margin-left: 2%;
}

.order_settle>em {
    margin-left: 3%;
    color: #333333;
    font-family: Lucida Grande, Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
}

.order_settle>em>.bell {
    width: 12px;
    height: 12px;
    vertical-align: baseline;
}

.order_settle>em>.Real {
    width: 60px;
    height: 22px;
    vertical-align: middle;
    cursor: pointer;
}


.active_divider {
    background: #ff8300;
    height: 1px;
    width: 170px;
}

.step_wrapper ::v-deep .ant-divider {
    margin: 0 20px;
    min-width: 170px;
}

.cert {
    display: inline-block;
    height: 18px;
    font-size: 12px;
    padding: 0 5px;
    right: 20px;
    position: absolute;
}

.cert0 {
    background: #E8EBFB;
    color: #6978B7;
}

.cert1 {
    background: #FFECBD;
    color: #FA9C00;
}

.cert2 {
    background: #FFD2D2;
    color: #FF1A36;
}

.cert:hover {
    opacity: 0.8;
}

.navs {
    margin-left: 40px;
    color: #333333;
    font-family: Lucida Grande, Helvetica, Arial, sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    border-bottom: 3px solid #ffffff;
    line-height: 44px;
    padding: 0 6px;
    margin-top: 17px;
}

.navs:nth-child(2) {
    margin-left: 30px;
}

.navs>span {
    display: inline-block;
    height: 100%;
    font-family: Lucida Grande, Helvetica, Arial, sans-serif;
}

.navs:hover {
    color: #fd5902;
}

.current {
    color: #fd5902;
    border-bottom: 3px solid #fd5902;
}

.header_nav {
    background: #ffffff;
    padding: 8px 21px;
    box-sizing: border-box;
    position: relative;
}

.ml75 {
    margin-left: 75px;
}

.header_logo_wrapper {
    width: 124px;
    height: 64px;
}

.logo {
    /* margin-right: 2.3%; */
    width: 180px;
}

.logo>.header_logo_wrapper {
    width: 100%;
}

.home_right_div {
    position: relative;
}

.home_right_adv {
    position: absolute;
    right: 0;
}

.top_img {
    width: 480px;
    height: 60px;
}

.sub_menu {
    width: 238px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.sub_menu>.subnavs {
    width: 48%;
    display: inline-block;
    color: #4a4a4a;
    font-family: Lucida Grande, Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    margin: 2.5% 0;
    font-size: 14px;
}

.sub_menu>.subnavs:hover {
    color: #fd5902;
}

@media screen and (max-width: 1400px) {
    .header_wrapper {
        width: 100%;
    }

    .sub_menu {
        width: 156px;
    }

    .sub_menu>.subnavs {
        font-size: 10px;
    }

}

@media screen and (max-width: 1280px) {

     .sub_menu {
        width: 86px;
    }

    .sub_menu>.subnavs {
        font-size: 5px;
    }

}


/* @media screen and (max-width: 1279px) {
    .header_wrapper {
        width: 100%;
    }

    .sub_menu {
        width: 108px;
    }

    .sub_menu>.subnavs {
        font-size: 7px;
    }


} */

/* @media screen and (min-width: 1440px) and (max-width: 1600px) {
    .header_wrapper {
        width: 100%;
    }

    .sub_menu {
        width: 188px;
    }

    .sub_menu>.subnavs {
        font-size: 12px;
    }

} */
</style>



// WEBPACK FOOTER //
// src/components/common/basic/BasicHeader.vue